import React, { useEffect, useState } from 'react'
import { AiFillEdit } from 'react-icons/ai'
import { MdDelete } from 'react-icons/md'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import AppLayout from '../components/AppLayout'
import { editPlanPrice, getPlan } from '../logic/plans/action'

const PlanPrices = () => {
    const selector = useSelector(state=>state.plans);
    const dispatch = useDispatch();
    const params = useParams();
    // const dispatch = useDispatch(); 
    // const selector = useSelector(state=>state.plans);
    const [features, setfeatures] = useState([]);
    const [open, setopen] = useState(false);
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  const [data, setdata] = useState({
    id:0,
    name:'',
    subscription:0,
    month:0,
    price:0,
  });
    useEffect(() => {
      getPlan(dispatch);
    }, [])

    const editplanClick = ()=>{
      console.log('clicked');
        editPlanPrice(dispatch,data);
        setopen(false);
    }
    
  return (
  <AppLayout>
  <div className="flex-1 h-full flex flex-col items-start gap-10 p-10 justify-center">
    <div className="flex justify-between w-full">
      <h1 className="font-bold text-2xl">Plan Details</h1>
      <Link to={"/admin/plans/add/prices"}>
        <button className="w-12 h-12 rounded-full">+</button>
      </Link>
    </div>
    <h4>Plan - {selector?.plans?.find(el=>el.id === parseInt(params.id))?.name}</h4>
    {/* <h4></h4>
    <h4></h4> */}
    <div className={`w-screen h-screen bg-black/40 ${open?'flex':'hidden'} items-center justify-center fixed top-0 left-0`}>
          <div className='w-1/2 h-1/2 p-10 overflow-y-scroll flex flex-col items-center gap-4 bg-white rounded-lg'>
              <h2>Edit plan</h2>
              <div className='w-full flex flex-col items-start gap-2'>
        <label htmlFor="name">Plan Name</label>
        
        <select 
          onChange={(ev)=>setdata(prev=>({...prev,subscription:ev.target.value}))}
          value={data.subscription}
    className='h-10 outline-none rounded-md px-4 w-full border-blue-800 border' name="Type" id="Type" >
    <option value={0} disabled selected>Select Plan</option>
    {
      selector.plans?.map(
        (el,i)=><option value={el.id}>{el.name}</option>
      )
    }
  </select>
        {/* <input placeholder='Plan Name' name='name' id='name' value={data.name} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/> */}
          </div>
          <div className='w-full flex flex-col items-start gap-2'>
        {/* <input placeholder='Plan Price'/> */}
        <label htmlFor="patient_limit">Patient Limit</label>
          <input placeholder='Plan Month' name='month' id='month' value={data.month} onChange={(ev)=>setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}/>
        {/* <input placeholder='Customer Limit' name='customer_limit' id='customer_limit' value={data.customer_limit} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/> */}
          </div>
          <div className='w-full flex flex-col items-start gap-2'>
        <label htmlFor="staff_limit">Staff Limit</label>
          <input placeholder='Plan Price' name='price' id='price' value={data.price} onChange={(ev)=>setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}/>
        {/* <input placeholder='Staff Limit' name='staff_limit' id='staff_limit' value={data.staff_limit} onChange={(ev)=>{setdata(prev=>({...prev,[ev.target.name]:ev.target.value}))}}/> */}
          </div>
          
        <button onClick={editplanClick}>EDIT PLAN</button>
          </div>
      </div>
    <div className="w-full h-[80%] flex flex-col shadow-lg gap-4">
          <div className="py-4 h-auto flex w-full bg-gray-500 text-white font bold">
            <p className="flex-1 text-center">Id</p>
            <p className="flex-1 text-center">Month</p>
            <p className="flex-1 text-center">Price</p>
            <p className="flex-1 text-center">Action</p>
          </div>
          <div className="flex-1 overflow-y-scroll">
            {
                selector?.plansPrices?.filter(el=>el.subscription === parseInt(params.id)).map(
                    (e,i)=><div className='py-4 flex w-full border-b-[0.1px] border-gray-500 font bold' key={i}>
                        <p className='flex-1 text-center capitalize'>{e?.id}</p>
                        <p className='flex-1 text-center capitalize'>{e?.month}</p>
                        <p className='flex-1 text-center capitalize'>₹{e?.price}</p>
                        {/* <p className='flex-1 text-center capitalize'>{e?.staff_limit === 100000 ? 'Unlimited':e?.staff_limit}</p>
                        <p className='flex-1 text-center capitalize'>{e?.customer_limit === 100000 ? 'Unlimited':e?.customer_limit}</p>
                        <p className='flex-1 text-center capitalize'>{e?.storage_limit>1024? e?.storage_limit / 1024 : e?.storage_limit} {e?.storage_limit>1024? 'GB' : 'MB'}</p>
                        <p className='flex-1 text-center capitalize'>{e?.sms_limit === 100000 ? 'Unlimited':e?.sms_limit}</p>
                        <p className='flex-1 text-center capitalize text-blue-500 underline'>
                           <Link to={`/plans/${e?.id}`}>
                           see
                           </Link> 
                        </p> */}
                        <p className="flex-1 text-center">
                  <span className="flex gap-4 justify-center items-center">
                    <AiFillEdit
                      className="cursor-pointer"
                      // onClick={setEditMode}
                      onClick={()=>{
                       setdata({
                        subscription:e?.subscription,
                        id:e?.id,
                        month:e?.month,
                        price:e?.price
                       });
                       setopen(true); 
                      }}
                    />

<MdDelete color='red'/>
                  </span>
                </p>
                    </div>
                )
            }
          </div>
          </div>
    </div>
    </AppLayout>
  )
}

export default PlanPrices